export class LocalStorageValue<T> {
  public get value(): T | undefined {
    return this.memoryValue ?? this.defaultValue
  }

  public set value(newValue: T | undefined) {
    if (this.memoryValue === newValue) return

    this.memoryValue = newValue

    if (newValue === undefined) {
      localStorage.removeItem(this.key)
      return
    }

    localStorage.setItem(this.key, this.serialize(newValue))
  }

  public get wasRead(): boolean {
    return this._wasRead
  }

  private _wasRead = false
  private memoryValue: T | undefined

  constructor(
    private readonly key: string,
    private readonly serialize: (value: T) => string,
    private readonly deserialize: (raw: string) => T,
    private readonly defaultValue?: T,
  ) {}

  public read(): T | undefined {
    this._wasRead = true
    const raw = localStorage.getItem(this.key)
    if (raw === null) {
      this.memoryValue = this.defaultValue
    } else {
      this.memoryValue = this.deserialize(raw)
    }
    return this.memoryValue
  }
}
